import React from 'react';
import { useNavigate } from 'react-router-dom';

import Panel from '../../components/Panel';

import Image from '../../assets/svg/cadastroManualProdutos.svg';
import ImageMobile from '../../assets/svg/cadastroManualProdutosMobile.svg';
import Typography from '../../components/Typography';

const NonApprovedIntegrators = () => {
  const navigate = useNavigate();

  const goToEnvvias = () => {
    navigate('/step/freight/envvias', { replace: true });
  };

  return (
    <div>
      <Panel
        panelType="information"
        title="Emissão manual de etiquetas Envvias"
        className=""
        tooltipText={
          <>Envvias é a nossa solução logística, que ajuda na operação e gestão das entregas.</>
        }
        description={
          <>
            <Typography className="max-w-[88%]">
              Sua integradora não é homologada no Envvias, por esse motivo{' '}
              <strong>é só emitir as etiquetas de envios no nosso Portal do Lojista.</strong>{' '}
            </Typography>
            <br />
            <Typography variant="link" className="text-support2-medium">
              <a href="manualEnvvias.pdf" target="_blank" rel="noreferrer" download>
                Clique aqui e saiba mais
              </a>
            </Typography>
          </>
        }
        image={Image}
        imageMobile={ImageMobile}
        buttonText="Ok, entendi!"
        onClick={goToEnvvias}
        buttonId="mp__pas-non-approved-integrators_button"
      />
    </div>
  );
};

export { NonApprovedIntegrators };
